import { NavLink } from 'react-router-dom'

import { NavBadge } from 'components/app-shell/atoms/NavBadge'
import { t } from 'lib/i18n'

const TABS = [
  { ar: 'عام', en: 'General', to: '/admin/settings/general' },
  { ar: 'اللغة والمنطقة', en: 'Language and region', to: '/admin/settings/language' },
  { ar: 'المظهر', en: 'Appearance', to: '/admin/settings/appearance' },
  { ar: 'الإشعارات والتذكيرات', en: 'Notifications', to: '/admin/settings/notifications' },
  { ar: 'التكاملات', en: 'Integrations', soon: true },
  { ar: 'الأمان', en: 'Security', to: '/admin/settings/security' },
]

/** Shared sub-nav across the global (org-wide, single-tenant) admin Settings pages
 *  (Figma: Admin / 30-35 · Settings — the General/Language/Appearance/Notifications/Integrations/Security tab strip). */
export const SettingsTabs = () => (
  <nav className="tabs" aria-label={t('إعدادات النظام', 'Settings')}>
    {TABS.map((tab) =>
      tab.to ? (
        <NavLink key={tab.to} to={tab.to} className={({ isActive }) => (isActive ? 'tab is-active' : 'tab')}>
          {t(tab.ar, tab.en)}
        </NavLink>
      ) : (
        <span key={tab.ar} className="tab is-disabled" aria-disabled="true">
          {t(tab.ar, tab.en)} <NavBadge>{t('قريباً', 'Soon')}</NavBadge>
        </span>
      ),
    )}
  </nav>
)
